<template>
    <div class="rate-card-store-groups-cell">
        <v-autocomplete
            v-if="isEditing"
            v-model="value"
            v-model:menu="menuOpen"
            :items="params.options"
            item-title="description"
            item-value="key"
            multiple
            closable-chips
            chips
            return-object
            class="rtls-select primary--text my-2"
            density="compact"
            variant="filled"
            :menu-props="{
                closeOnContentClick: false,
                bottom: true,
                offsetY: true,
                openOnClick: false,
                scrollStrategy: 'none',
            }"
            @update:model-value="onModelChange"
            @update:menu="onMenuChanged"
            @blur="persistValue"
        />
        <chips-list
            v-else
            :items="params.value || []"
            field="description"
            :max-num-chips-to-display="2"
        />
    </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import ChipsList from '@/js/components/chips-list.vue';

export default {
    components: {
        ChipsList,
    },
    props: {
        params: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            lastPersistedValue: [],
            menuOpen: false,
            value: [],
        };
    },
    computed: {
        isEditing() {
            return this.params.isEditing(this.params.data._id);
        },
        displayValue() {
            return (this.params.value || [])
                .map(({ description, key }) => description || key)
                .join(', ');
        },
    },
    created() {
        this.value = cloneDeep(this.params.value || []);
        this.lastPersistedValue = cloneDeep(this.params.value || []);
    },
    methods: {
        onModelChange(newValue) {
            this.value = cloneDeep(newValue || []);
        },
        onMenuChanged(value) {
            this.menuOpen = value;
            if (!value) {
                this.persistValue();
            }
        },
        persistValue() {
            if (this.menuOpen) {
                return;
            }

            const serialisedCurrent = JSON.stringify(this.value || []);
            const serialisedPersisted = JSON.stringify(this.lastPersistedValue || []);

            if (serialisedCurrent === serialisedPersisted) {
                return;
            }

            this.lastPersistedValue = cloneDeep(this.value || []);
            this.params.onChange({
                id: this.params.data._id,
                field: 'storeGroups',
                value: this.value,
            });
        },
    },
};
</script>

<style scoped lang="scss">
.rate-card-store-groups-cell {
    width: 100%;
    padding: 0.2rem 0;

    :deep(.v-autocomplete.v-input) {
        min-width: 22rem;
        margin: 0;
    }

    :deep(.v-field__input) {
        padding-top: 0.2rem !important;
        padding-bottom: 0.2rem !important;
    }

    :deep(.v-chip) {
        max-width: 100%;
    }
}
</style>
